import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesServicesVideoMain } from './modules/ui/Main';

const ServicesVideoPage = (
  <SuspensePage>
    <PagesServicesVideoMain />
  </SuspensePage>
);

export default ServicesVideoPage;
